import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 -960 960 960"

const GradeIconFilled = createSvgIcon(
  <>
    <path d='m233-120 65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z' />
  </>,
  'GradeIconFilled'
)

export default GradeIconFilled
